/**
 * @generated SignedSource<<05bec412e21f6027ca4fb1c5f1a5e4df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ScrapActionEnum = "scrap_delete" | "scrap_image_update" | "scrap_task_restore" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ScrapSourceScrapConnectionDataTable_scrapConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly actions: ReadonlyArray<ScrapActionEnum>;
      readonly id: string;
      readonly problemBookPage: number;
      readonly problemNumber: string;
      readonly solutionBookPage: number;
      readonly task: {
        readonly id: string;
        readonly isDeleted: boolean;
        readonly sequence: number;
      } | null;
    };
  }>;
  readonly totalCount: number | null;
  readonly " $fragmentType": "ScrapSourceScrapConnectionDataTable_scrapConnection";
};
export type ScrapSourceScrapConnectionDataTable_scrapConnection$key = {
  readonly " $data"?: ScrapSourceScrapConnectionDataTable_scrapConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScrapSourceScrapConnectionDataTable_scrapConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScrapSourceScrapConnectionDataTable_scrapConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ScrapEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Scrap",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "problemNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "problemBookPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "solutionBookPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "task",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sequence",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDeleted",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ScrapConnection",
  "abstractKey": null
};
})();

(node as any).hash = "d75ce9a3f4a7d6b75233cb1d0e546390";

export default node;
